import { adminListingQueryKeys as e } from "./adminListingQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminListingsApi as r } from "@maat/api-main";
//#region src/listings/admin/useAdminUpdateListingAmenitiesMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, amenityIds: t }) => r.updateAmenities(e, { amenityIds: t }),
		onSuccess: (t, { id: n }) => {
			i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useAdminUpdateListingAmenitiesMutation };
